var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMultiBorrowerRequest
    ? _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "a",
              {
                staticClass: "bold tiny grey-text text-uppercase clickable",
                on: { click: _vm.toggleExpand },
              },
              [
                _c("icon", {
                  staticClass: "text-primary",
                  attrs: { name: "file-text" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1 text-light-gray" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("application.applicationsShared")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("icon", {
                  attrs: { name: _vm.expanded ? "caret-up" : "caret-down" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.expanded
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "flex-wrap" },
                    _vm._l(
                      _vm.filteredSharedApplications,
                      function (applicant, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            staticClass: "timeline-signer-item mb-3",
                            attrs: { xl: "3", lg: "auto", md: "6", cols: "12" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "timeline-signer clickable" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "small text-gray w-100 mb-0 regular-line-height px-2",
                                  },
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.status")) +
                                          ": "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "badge",
                                      {
                                        staticClass: "ml-0 mb-0",
                                        class: _vm.getBadgeType(
                                          applicant.status
                                        ),
                                        staticStyle: { "font-size": "0.5rem" },
                                        attrs: { type: "" },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(applicant.status) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "small text-gray w-100 mb-0 regular-line-height px-2",
                                    class: {
                                      "word-break-all":
                                        _vm.filteredSharedApplications.length >
                                        1,
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "client-profile.timeline.consolidatedRequest.applicantEmail"
                                          )
                                        ) + ":\n            "
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          applicant.email ||
                                            applicant.alternateEmail
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "small text-gray w-100 mb-0 regular-line-height px-2",
                                  },
                                  [
                                    _c("span", { staticClass: "bold" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("global.words.sections")
                                        ) + ": "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getSharedApplicationSections(
                                              applicant
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _c("div", [
        _c(
          "a",
          { staticClass: "bold tiny grey-text text-uppercase" },
          [
            _c("icon", {
              staticClass: "text-primary",
              attrs: { name: "file-text" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mx-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application.applicationShared")) +
                  "\n    "
              ),
            ]),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }